"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmenuItem = _styledComponents.default.li.attrs({
  className: "menuItem ".concat(function (p) {
    return p.className;
  })
}).withConfig({
  displayName: "SubmenuItem",
  componentId: "sc-1h4sayo-0"
})(["display:flex;font-size:1rem;@media ", "{font-size:0.875rem;}", " ", ""], (0, _helpers.breakpoint)('maxMobile'), function (p) {
  return p.centered && 'justify-content: center;';
}, function (p) {
  return p.padded && 'padding: 1rem;';
});

var _default = SubmenuItem;
exports.default = _default;